<template>
    <div style="box-sizing: border-box;padding: 20px 0 50px;">
        <div class="forms">
            <div class="title flx alc">
                <div class="shu"></div>
                <div class="tits">
                    全部简历
                </div>
            </div>
            <div class="coninners flx jsb">
                <div class="inItem flx alc jsb" v-for="item,index in list">
                    <div class="iileft">
                        <div class="iiTop" v-text="item.nickname">

                        </div>
                        <div class="iiBottom" v-text="`投递时间:${item.createtime}`">

                        </div>
                    </div>
                    <div class="iiright">
                        <a :href="$img(item.resume)" download="">下载简历</a>
                    </div>
                </div>
            </div>
            <el-pagination background layout="prev, pager, next" :total="1000">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import{getJl} from "@/api/index.js"
    export default {
        data() {
            return {
                list: [],
                id:"",
                page:1,
                size:20
            }
        },
        created() {
            this.id = this.$route.query.id
            this.getList()
        },
        methods: {
            getList(){
                let that = this 
                let data = {}
                data.page = that.page
                data.size = that.size
                data.id = that.id 
                getJl(data).then((res) => {
                    if(res.code == 1){
                        that.list = res.data.data
                    }
                })
            }
        }
    }
</script>

<style scoped>
    a {
        /* 去掉下划线 */
        text-decoration: none;
        /* 去掉默认蓝色 */
        color: #007AFF !important;
        /* 鼠标点击高亮清除（可选） */
        -webkit-tap-highlight-color: transparent;
    }

    /* 鼠标悬浮、访问后、点击时都不变色 */
    a:hover,
    a:visited,
    a:active,
    a:focus {
        text-decoration: none;
        color: inherit;
        outline: none;
        /* 去除焦点虚线框 */
    }

    .iiBottom {
        font-size: 14px;
        color: #555C70;
    }

    .iiTop {
        text-align: left;
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 16px;
    }

    .inItem {
        width: 690px;
        height: 101px;
        border-radius: 10px;
        border: 1px solid #D9D9D9;
        box-sizing: border-box;
        padding: 0 20px;
        margin-bottom: 20px;
    }

    .coninners {
        flex-wrap: wrap;
        margin-bottom: 30px;
        height:1200px
    }

    .shu {
        width: 3px;
        height: 16px;
        background: #007AFF;
    }

    .tits {
        font-weight: 600;
        font-size: 18px;
        margin-left: 12px;
    }

    .title {
        margin-bottom: 30px;
    }

    .forms {
        width: 1460px;
        height: 1400px;
        background-color: #fff !important;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 45px 30px;
        position: relative;
    }
</style>